// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import { Checkbox, View, Text } from "@components";
import type { SpecialContactType } from "@modules/shared/reducer/special-contact-types/types";
import type { AlertSpecialContactType } from "@modules/service/reducer/alerts/types";
import { transformToValidId } from "@transformers/string";

type RecipientOption = $Exact<{ id: number, label: string }>;

type OwnProps = $Exact<{
  data: ?Array<AlertSpecialContactType>,
  options: Array<SpecialContactType>,
  onChange?: (data: ?Array<AlertSpecialContactType>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class AlertRecipientsForm extends React.Component<Props> {
  get options(): Array<RecipientOption> {
    return this.props.options ? this.props.options.map(r => ({ id: r.id, label: r.name })) : [];
  }

  handleChange = (option: RecipientOption) => () => {
    if (this.props.onChange) {
      const found = option && this.props.data && this.props.data.find(d => d.id == option.id);
      const next = found
        ? this.props.data.filter(d => d.id !== option.id)
        : [...(this.props.data || []), { id: option.id, name: option.label }];

      this.props.onChange(next);
    }
  };

  render() {
    return (
      <View gap={3} className="gs-container">
        <View>
          <Text type="h6" text={this.props.t("DEFAULT")} />
        </View>
        <View display="grid" gap={1} gridTemplateColumns={3}>
          {this.options.map(o => (
            <Checkbox
              key={o.id}
              id={transformToValidId(`${o.label}-${o.id}`)}
              label={o.label}
              checked={!!(this.props.data || []).find(d => d.id === o.id)}
              onChange={this.handleChange(o)}
            />
          ))}
        </View>
      </View>
    );
  }
}

export default localize()(AlertRecipientsForm);
